import Vue from "vue";
import Vuex from "vuex";
import CounterModule from "./modules/counter";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        CounterModule
    }
});
